module.exports = __webpack_public_path__ + "static/ngrok-webhooks-1e1d6799d0c40a07eba2c967f52760a8.png";